import { useQuery } from '@tanstack/react-query'
import { xdrHealthQuery, type XdrFlowProblem } from '../api/securitee'

/** 27 -> "27 min", 135 -> "2 h 15 min". */
export function flowAge(minutes: number): string {
  if (minutes < 60) return `${minutes} min`
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  return m === 0 ? `${h} h` : `${h} h ${m} min`
}

const TEXT: Record<XdrFlowProblem['part'], (m: number) => string> = {
  forward: (m) => `Events have not been sent to Wazuh for ${flowAge(m)}. New attacks will not raise incidents until this is fixed.`,
  read: (m) => `Wazuh alerts have not been read for ${flowAge(m)}. Detections and incidents are not updating.`,
  native: (m) => `OptimumDesk has not evaluated new events for ${flowAge(m)}. New attacks will not raise incidents until this is fixed.`,
}

/**
 * Fluxul XDR s-a oprit (GET /securitee/xdr/health): banda rosie sus in
 * Incidents si Detections. Fara problema, fara drept sau cu eroare: nimic -
 * banda nu strica pagina pe care sta.
 */
export function XdrFlowAlert() {
  const q = useQuery(xdrHealthQuery())
  const problems = q.data?.problems ?? []
  if (problems.length === 0) return null

  return (
    <div className="alert alert-danger xdr-flow-alert" role="alert" style={{ marginBottom: 12 }}>
      <strong>XDR flow stopped.</strong>
      <ul style={{ margin: '4px 0', paddingLeft: 18 }}>
        {problems.map((p) => (
          <li key={p.part}>{TEXT[p.part](p.minutes)}</li>
        ))}
      </ul>
      {problems.every((p) => p.part === 'native')
        ? 'Ask a platform admin to check the XDR engine on the API server.'
        : 'Ask a platform admin to check the Wazuh connection in Settings > Securitee > XDR.'}
    </div>
  )
}
